<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [placeholder]="placeholder"
    [matTooltip]="tooltip"
    (keyup)="onKeyup($event)" />
</mat-form-field>

